import InputActivityReport from "./InputActivityReport";
export default InputActivityReport;